import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NavActionProps } from '~/App/Components/Typeform/NavAction';

export type State = NavActionProps;

export const initialState: State = {
  onNextClick: () => undefined,
  onPreviousClick: () => undefined,
  nextDisabled: false,
  previousDisabled: false,
};

const typeformNavSlice = createSlice({
  name: 'typeform-nav',
  initialState,
  reducers: {
    setActivePageOnNextClick(
      state: State,
      action: PayloadAction<() => Promise<void> | void | null>
    ) {
      state.onNextClick = action.payload;
    },
    setActivePageOnPrevClick(
      state: State,
      action: PayloadAction<() => Promise<void> | void | null>
    ) {
      state.onPreviousClick = action.payload;
    },
    setActivePageNextDisabled(state: State, action: PayloadAction<boolean>) {
      state.nextDisabled = action.payload;
    },
    setActivePagePrevDisabled(state: State, action: PayloadAction<boolean>) {
      state.previousDisabled = action.payload;
    },
  },
});

export const actions = typeformNavSlice.actions;
export default typeformNavSlice.reducer;
